export function parseQS(search) {
  search = search[0] === '?' ? search.substr(1) : search;
  return search.split('&')
    .reduce((qs, keyValue) => {
      const parts = keyValue.split('=');
      qs[parts[0]] = parts[1] || true;
      return qs;
    }, {});
}



// WEBPACK FOOTER //
// ./src/utils/qs.js